import React, { useEffect, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { ApiHttpService } from 'cms/utils/http/api';
import { PostHttpService } from 'cms/utils/http/post_http_service';

export default function PostVideoGalleryController(id) {

  const [videoGalleries, setVideoGalleries] = useState(null);
  const [addModalIsOpen, setAddModalIsOpen] = useState(false);

  const { isLoading, data ,refetch } = useQuery(['postGalleries', id], () =>
    PostHttpService.loadPostVideoGalleries(id),
    {
      onSuccess: (data) => {
        if (data.results) {
          setVideoGalleries(data.results)
        }
      },
    }
  );

  const closeModal = () => {
    setAddModalIsOpen(false)
}

  return {
    isLoading,
    videoGalleries,
    setVideoGalleries,
    closeModal,
    addModalIsOpen,
    setAddModalIsOpen,
    refetch
  };;
}
